import { render, staticRenderFns } from "./ConfigUserData.vue?vue&type=template&id=2c5e4d5c&scoped=true"
import script from "./ConfigUserData.vue?vue&type=script&lang=js"
export * from "./ConfigUserData.vue?vue&type=script&lang=js"
import style0 from "./ConfigUserData.vue?vue&type=style&index=0&id=2c5e4d5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5e4d5c",
  null
  
)

export default component.exports